var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.211,
    height: 56.497,
    viewBox: "0 0 46.211 56.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4811",
    "data-name": "Group 4811",
    transform: "translate(-34.604 -178.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21127",
    "data-name": "Path 21127",
    d: "M409.52,300.308c-1.859,8.252-6.626,27.519-11.462,31.548a2.822,2.822,0,0,1-1.076.635c-17,4.142-22.448-6.423-22.448-6.423s4.556-2.22,4.671-6.56l9.188,2.851,8.009-18.024,1.179-1.1.007-.007Z",
    transform: "translate(-334.318 -119.174)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21130",
    "data-name": "Path 21130",
    d: "M345.51,337.017l.136-48.925a3.739,3.739,0,0,1,3.745-3.725l36.949.1a3.739,3.739,0,0,1,3.725,3.745l-.136,48.925a3.739,3.739,0,0,1-3.745,3.725l-36.949-.1A3.739,3.739,0,0,1,345.51,337.017Z",
    transform: "translate(-310.085 -105.865)",
    fill: "#042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21131",
    "data-name": "Path 21131",
    d: "M362.928,337.11l.087-31.453a3.5,3.5,0,0,1,3.508-3.488l31.755.088a3.5,3.5,0,0,1,3.488,3.508l-.121,43.536a3.5,3.5,0,0,1-3.508,3.488l-19.671-.055A15.6,15.6,0,0,1,362.928,337.11Z",
    transform: "translate(-324.628 -120.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21132",
    "data-name": "Path 21132",
    d: "M422.28,370.839H397.52a1.486,1.486,0,1,1,0-2.971h24.76a1.486,1.486,0,0,1,0,2.971Z",
    transform: "translate(-352.269 -175.581)",
    fill: "#042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21133",
    "data-name": "Path 21133",
    d: "M402.967,329.339H397.52a1.486,1.486,0,1,1,0-2.971h5.447a1.486,1.486,0,1,1,0,2.971Z",
    transform: "translate(-352.269 -140.932)",
    fill: "#042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21134",
    "data-name": "Path 21134",
    d: "M422.28,412.339H397.52a1.486,1.486,0,0,1,0-2.971h24.76a1.486,1.486,0,0,1,0,2.971Z",
    transform: "translate(-352.269 -210.231)",
    fill: "#042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21135",
    "data-name": "Path 21135",
    d: "M422.28,453.839H397.52a1.486,1.486,0,1,1,0-2.971h24.76a1.486,1.486,0,0,1,0,2.971Z",
    transform: "translate(-352.269 -244.881)",
    fill: "#042"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 5.911,
    cy: 5.911,
    r: 5.911,
    transform: "translate(62.096 215.186)",
    fill: "#042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21136",
    "data-name": "Path 21136",
    d: "M526.529,529.922a.658.658,0,0,1-.526-.263l-1.613-2.15a.658.658,0,0,1,1.052-.789l1.055,1.407,2.71-4.065a.658.658,0,1,1,1.094.729l-3.225,4.838a.658.658,0,0,1-.529.293Z",
    transform: "translate(-459.328 -305.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    cx: 2.806,
    cy: 2.806,
    r: 2.806,
    transform: "translate(34.604 179.824)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 2.806,
    cy: 2.806,
    r: 2.806,
    transform: "translate(42.362 227.009)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 2.806,
    cy: 2.806,
    r: 2.806,
    transform: "translate(75.202 185.601)",
    fill: "#f2f2f2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsIcon);
export default __webpack_public_path__ + "static/media/docs_icon.1b81607cf2f6641a2b8548ddda144eee.svg";
export { ForwardRef as ReactComponent };